
import { Component } from 'vue-property-decorator';
import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';
import StoreDeliveryScheduleAddEdit from './StoreDeliveryScheduleAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class StoreDeliveryScheduleListItem {
  id: string = '';
  outletCode: string = '';
  orderType: string = '';
  status: string = '';
  beginDate: number = 10000101;
  endDate: number = 99991231;
  beginDay: number = 0;
  endDay: number = 0;
  beginHour: number = 0;
  endHour: number = 0;
}

@Component({
  components: {
    editor: StoreDeliveryScheduleAddEdit
  }
})
export default class StoreDeliveryScheduleList extends RemoteDataTable<
  StoreDeliveryScheduleListItem
  > {
  public pageTitle: string = 'Store Delivery Schedule List';

  public newButtonText: string = 'New Store Delivery Schedule';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'outletCode', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'orderType', label: 'Order Type' }),
    new RemoteDataField({ key: 'status', label: 'Status' }),
    new RemoteDataField({ key: 'beginDate', label: 'Begin Date' }),
    new RemoteDataField({ key: 'endDate', label: 'End Date' }),
    new RemoteDataField({ key: 'beginDay', label: 'Begin Day' }),
    new RemoteDataField({ key: 'endDay', label: 'End Day' }),
    new RemoteDataField({ key: 'beginHour', label: 'Begin Hour' }),
    new RemoteDataField({ key: 'endHour', label: 'End Hour' })
  ];

  // to get page data
  get items(): StoreDeliveryScheduleListItem[] {
    return this.$store.getters.GetAllStoreDeliverySchedule;
  }

  get paging(): StoreDeliveryScheduleListItem[] {
    return this.$store.getters.PagingStoreDeliverySchedule;
  }

  get sorting(): StoreDeliveryScheduleListItem[] {
    return this.$store.getters.SortingStoreDeliverySchedule;
  }

  get filtering(): StoreDeliveryScheduleListItem[] {
    return this.$store.getters.FilteringStoreDeliverySchedule;
  }

  resetSorting() {
    this.sortingChanged({ sortBy: '', sortDesc: '' });
  }

  resetFilter() {
    this.filterChanged(true);
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingStoreDeliverySchedule', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringStoreDeliverySchedule', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.storeDeliverySchedule.pagingStoreDeliverySchedule.page = 1;
    }
    this.$store.dispatch('GetAllStoreDeliverySchedule');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteStoreDeliverySchedule', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.storeDeliverySchedule.pagingStoreDeliverySchedule.size = page;
    this.$store.dispatch('GetAllStoreDeliverySchedule');
  }
}
